export const MENU_TEMPLATE = 'Web.TemplatesInterface.v1_0.Touch.MenuTemplateInterface.MenuTemplate';
